import React, {useState} from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {
    DATE_TIME_REACT_FORMAT,
    DATE_TIME_REACT_WITHOUT_HOUR_FORMAT,
    messageError,
    messageToast,
    objectLoai,
    objectLoaiNoiDung,
    objectTrangThaiDeNghi,
    status200,
    styleSelectDefault,
    styleSelectError
} from '../../utils/define';
import {addEmailConfigAction} from '../../store/reducers/emailConfig';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import {APIROLEMAPPING_API, ROLE_API} from '@app/utils/apiUrl';
import {useMutation, useQuery} from 'react-query';
import Editor from '@app/components/editor/Editor';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import {AsyncPaginate} from 'react-select-async-paginate';
import {Get, Post} from '@app/utils/httpProvider';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    controller: yup.string().required('Bắt buộc'),
    lstAllowedRoles: yup.array().min(1, 'Phải chọn ít nhất 1 quyền')
});

const ApiRoleMappingAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const addFunc = useMutation((value) =>
        Post(APIROLEMAPPING_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const model = values;

        // model.lstAllowedRoles = values.lstAllowedRoles.map((x) => ({
        //     id: x.value,
        //     name: x.label
        // }));

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const listRole = useQuery(['getAllRolesFromAuthServer'], () =>
        Get(ROLE_API.GET_PAGING, null, {
            PageIndex: 1,
            PageSize: 10000
        })
    );

    const lstRole =
        listRole &&
        listRole.data &&
        listRole.data.data &&
        listRole.data.data.length > 0
            ? listRole.data.data.map((x) => ({
                  name: x.name,
                  id: x.id
              }))
            : [];

    const loadOptions = async (inputValue, loadedOptions, {page}) => {
        const filtered = lstRole
            .filter((o) =>
                o.name.toLowerCase().includes(inputValue.toLowerCase())
            )
            .slice(0, 6);
        return {
            options: filtered,
            hasMore: false,
            additional: {page: page + 1}
        };
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm thông tin Api Role Mapping</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        controller: '',
                        action: '',
                        lstAllowedRoles: []
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        errors,
                        setFieldValue
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            {/* <Form.Group as={Row} className="mb-3">
                                <Col sm="6">
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Tên controller
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control
                                                placeholder="Tên controller"
                                                type="text"
                                                name="controller"
                                                value={values.controller}
                                                onChange={handleChange}
                                                isInvalid={!!errors.controller}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.controller}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col sm="6">
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label className="col-sm-2 col-form-label">
                                            Tên action
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control
                                                placeholder="Tên action"
                                                type="text"
                                                name="action"
                                                value={values.action}
                                                onChange={handleChange}
                                                isInvalid={!!errors.action}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.action}
                                            </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Form.Group> */}
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Tên controller',
                                        name: 'controller',
                                        value: values.controller,
                                        onChange: handleChange,
                                        isInvalid: errors.controller,
                                        error: errors.controller
                                    },
                                    {
                                        label: 'Tên action',
                                        name: 'action',
                                        value: values.action,
                                        onChange: handleChange,
                                        isInvalid: errors.action,
                                        error: errors.action
                                    }
                                ]}
                            />
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Quyền được cho phép truy cập
                                </Form.Label>
                                <Col sm="10">
                                    <AsyncPaginate
                                        isMulti
                                        name="lstAllowedRoles"
                                        placeholder="Chọn quyền được cho phép truy cập"
                                        value={values.lstAllowedRoles}
                                        getOptionLabel={(opt) => opt.name}
                                        getOptionValue={(opt) => opt.id}
                                        loadOptions={loadOptions}
                                        styles={
                                            errors.lstAllowedRoles
                                                ? styleSelectError
                                                : styleSelectDefault
                                        }
                                        onChange={(options) => {
                                            setFieldValue(
                                                'lstAllowedRoles',
                                                options
                                            );
                                        }}
                                        additional={{
                                            page: 1
                                        }}
                                    />
                                    <div
                                        className="invalid-feedback"
                                        style={{display: 'block'}}
                                    >
                                        {errors.lstAllowedRoles}
                                    </div>
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3">
                                <Col md={{span: 10, offset: 2}}>
                                    <ButtonGroup className="mb-2">
                                        <Button
                                            type="submit"
                                            theme="primary"
                                            disabled={isLoading}
                                        >
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button
                                            onClick={() => history.goBack()}
                                            theme="secondary"
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
                <ReactSpinner loadings={isLoading} />
            </Card.Body>
        </Card>
    );
};

export default ApiRoleMappingAdd;
